import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { faBell, faHome } from '@fortawesome/pro-regular-svg-icons';
import BottomNavbarItem from '@/inpatient-patient-pwa/molecules/BottomNavbarItem';
import { useNavbar } from '@/inpatient-patient-pwa/contexts/navbar/useNavbar';
import styles from './BottomNavbar.module.scss';

const BottomNavbar: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { activeAlerts } = useNavbar();

  return (
    <nav className={classNames('navbar-bottom', styles.wrapper)}>
      <div className="container">
        <ul className="d-flex flex-justify-around w-100">
          <BottomNavbarItem icon={faHome} text={t('nav.home')} to="/" exact />
          <BottomNavbarItem
            icon={faBell}
            text={t('nav.orders')}
            to="/calls"
            exact
            badgeText={activeAlerts ? `${activeAlerts}` : undefined}
          />
        </ul>
      </div>
    </nav>
  );
};

export default BottomNavbar;
